import { render, staticRenderFns } from "./SportsList.vue?vue&type=template&id=c8fd0b06"
import script from "./SportsList.vue?vue&type=script&lang=js"
export * from "./SportsList.vue?vue&type=script&lang=js"
import style0 from "./SportsList.vue?vue&type=style&index=0&id=c8fd0b06&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports